import { __assign } from "tslib";
import { isEmpty } from 'lodash-es';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PanelCode from '../../components/handoff/PanelCode';
import onlyIf from '../../hocs/onlyIf';
import { getSelectedElementCode } from '../../selectors/code';
import { getSelectedElement } from '../../selectors/handoff';
function mapStateToProps(state) {
    var element = getSelectedElement(state);
    if (!element) {
        return {};
    }
    return __assign({ element: element }, getSelectedElementCode(state));
}
export default compose(connect(mapStateToProps), onlyIf(function (_a) {
    var code = _a.code, currentLang = _a.currentLang;
    return !isEmpty(code[currentLang]);
}))(PanelCode);
